import { sendData } from 'connectors/kinesis';
import cookie from 'cookie';
import useIsClient from 'hooks/common/use-is-client';
import { Gtm } from 'tracking';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

declare global {
  interface Window {
    __pageViewCache?: Set<string>;
  }
}

const PageViewTrigger: React.FC = () => {
  const router = useRouter();
  const isClient = useIsClient();

  useEffect(() => {
    if (!isClient) return;

    Gtm.track.pageView();

    const minute = Math.floor(Date.now() / 60000);
    const cacheKey = `${router.asPath}-${minute}`;

    // Initialize or get existing cache
    const cache = window.__pageViewCache || new Set<string>();
    window.__pageViewCache = cache;

    if (!cache.has(cacheKey)) {
      const gaSessionId = cookie.parse(document.cookie)._ga;
      const timestamp = new Date().toISOString();
      const randomSuffix = Math.floor(Math.random() * 1000);
      const partitionKey = `${gaSessionId ?? ''}-${timestamp}-${randomSuffix}`;

      const eventData = {
        eventName: 'pageView',
        schemaVersion: '0.0.1',
        payload: {
          pagePath: router.asPath,
        },
      };

      sendData({
        eventData,
        partitionKey,
      });

      cache.add(cacheKey);
    }
  }, [isClient, router.asPath]);

  return null;
};

export default PageViewTrigger;
